module.exports = __webpack_public_path__ + "assets/img/accounts.297fc756.svg";